// reloadWarningSuppress.ts — erlaubt einzelnen Seiten, die globale
// beforeunload-„Seite verlassen?"-Warnung (NavigationLayout, AC1d — Nag bei
// ungelesenen Mitteilungen) temporär zu unterdrücken. Bewusst ein Modul-Flag
// (kein Context): der beforeunload-Handler liest es synchron im Event, ohne sich
// neu zu registrieren — analog zum dortigen unreadCountRef.
//
// Nutzung: Seite ruft beim Mounten setReloadWarningSuppressed(true) und beim
// Unmounten setReloadWarningSuppressed(false) (siehe HaushalteCleanupPage).

let suppressed = false;

export function setReloadWarningSuppressed(value: boolean): void {
  suppressed = value;
}

export function isReloadWarningSuppressed(): boolean {
  return suppressed;
}
